
import { LogLevel } from '@azure/msal-browser';
import { ENTRA_CLIENT_ID, ENTRA_AUTHORITY, ENTRA_REDIRECT_URI, ENTRA_POST_LOGOUT_REDIRECT_URI } from './config/Config';

export const msalConfig = {
    auth: {
        clientId: ENTRA_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
        authority: ENTRA_AUTHORITY, // Replace the placeholder with your tenant subdomain 
        redirectUri: ENTRA_REDIRECT_URI, // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        postLogoutRedirectUri: ENTRA_POST_LOGOUT_REDIRECT_URI, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    // case LogLevel.Info:
                    //     console.info(message);
                    //     return;
                    // case LogLevel.Verbose:
                    //     console.debug(message);
                    //     return;
                    // case LogLevel.Warning:
                    //     console.warn(message);
                    //     return;
                    default:
                        return;
                }
            },
        },
    },
};


export const loginRequest = {
    scopes: [],
};

